export interface ServiceStatusItemDTO {
    serviceId: string;
    isHealthy: boolean;
    isStale: boolean;
    thresholdSeconds: number;
    ageSeconds: number;
    lastSeenUtc: string;
    updatedAtUtc: string;
    message: string;
}

export interface ServiceStatusPopupState {
    isOpen: boolean;
    affectedServices: string[];
    isGenericFailure: boolean;
}

const buildServicesUrl = (): string | null => {
    const statusApiUrl = process.env.REACT_APP_STATUS_API_URL;

    if (!statusApiUrl) {
        return null;
    }

    return `${statusApiUrl.replace(/\/$/, "")}/api/services`;
};

export const getServiceStatus = async (): Promise<ServiceStatusItemDTO[]> => {
    const url = buildServicesUrl();

    if (!url) {
        throw new Error("REACT_APP_STATUS_API_URL is not configured.");
    }

    const response = await fetch(url, { method: "GET" });
    if (!response.ok) {
        throw new Error(`Service status request failed with status ${response.status}.`);
    }

    const data = await response.json() as ServiceStatusItemDTO[];
    return Array.isArray(data) ? data : [];
};

const normalizeServiceName = (serviceId: string): string => {
    return serviceId.replace("-Prod", "").trim();
};

export const buildServiceStatusPopupState = (
    statuses: ServiceStatusItemDTO[]
): ServiceStatusPopupState => {
    const affectedServices = statuses
        .filter((status) => !status.isHealthy && status.serviceId.includes("-Prod"))
        .map((status) => normalizeServiceName(status.serviceId));

    return {
        isOpen: affectedServices.length > 0,
        affectedServices,
        isGenericFailure: false,
    };
};

export const buildServiceStatusFailureState = (): ServiceStatusPopupState => {
    return {
        isOpen: true,
        affectedServices: [],
        isGenericFailure: true,
    };
};